import loaderGif from 'assets/images/loader.gif';
export const Loader = ({
  style = {},
  children = undefined
}: {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}) => {
  return (
    <div
      style={{
        // width: 'fit-content',
        margin: '-8px auto', // -8px to prevent overflow, only needed with height 100vh.
        display: 'flex',
        alignItems: 'center',
        height: '100vh',
        ...style
      }}
    >
      <img src={loaderGif} height="50px" width="50px" alt="loader" />
      {children}
    </div>
  );
};
